



import { useNavigate, useParams } from "react-router-dom";
import Login from '../../../components/azuldirecta/inicio/componente'
import React, { useEffect, useState } from "react";
import FooterNavigation from '../../../components/azuldirecta/footer'; // Ajustá la ruta si es necesario


export default function Paginas() {
    const navigate = useNavigate();
    const [loginVisible, setLoginvisible] = useState(false)

   

    return (
        <>
    
   
        <Login/>
       <FooterNavigation/>
        </>
   
    );

}